import { useTranslation } from 'react-i18next';
import { FirstConsultationOwnView } from '@/components/common/FirstConsultationOwnView';
import { Button } from '@/components/ui/button';
import { ModalOverlay } from '@/components/ui/modalOverlay';
import type { OwnerPreviewContent } from './ownerPreview';

interface OwnerPreviewModalProps {
  content: OwnerPreviewContent;
  onClose: () => void;
}

export function OwnerPreviewModal({ content, onClose }: OwnerPreviewModalProps) {
  const { t } = useTranslation(['consultations', 'common']);

  return (
    <ModalOverlay onRequestClose={onClose} ariaLabel={t('consultations:sharing.previewTitle')}>
      <div className="w-full max-w-2xl max-h-[90vh] overflow-y-auto bg-zoowhite border border-zooborder rounded-3xl shadow-2xl p-7">
        <h2 className="text-lg font-bold text-zooindigo">
          {t('consultations:sharing.previewTitle')}
        </h2>
        <p className="text-xs text-zoomuted mt-1 mb-4">{t('consultations:sharing.previewHint')}</p>
        <FirstConsultationOwnView
          answers={content.answers}
          outcome={content.outcome}
          notes={content.notes}
        />
        <div className="flex justify-end mt-6">
          <Button variant="outline" onClick={onClose}>
            {t('common:actions.close')}
          </Button>
        </div>
      </div>
    </ModalOverlay>
  );
}
